module.exports = __webpack_public_path__ + "static/media/pastafarianism.302fecf7.svg";